import { DataTypes } from "../types";
import { PRODUCT_TIERS } from "./constants";

// Helper function to check if a migration set import type is in the old format (pre-data import type selection screen)
// Old format: "staff;contact;matter" (semicolon-separated string) or an empty string
// New format: '["Staff","Contact","Matter"]'
export const isOldFormatImportType = (importTypeString: string): boolean => {
  return !importTypeString || !importTypeString.startsWith('["'); // Checks if it's not a properly formatted JSON array with strings
};

// Helper function to get allowed import types based on region/tier for old formats
// If productId is empty, this function returns only basic import types (excluding memos, tasks, events, matter tags, matter relationships, 
// matter critical dates, and safe custody packets/docs).
// This is for legacy imports
export const getAllowedImportTypes = (
  region: string,
  productId: string,
): string[] => {
  const isGrowOrProsper =
    productId === PRODUCT_TIERS.GROW || productId === PRODUCT_TIERS.PROSPER;

  const allowedImportTypes = [
    DataTypes.Staff,
    DataTypes.Contacts,
    DataTypes.Matters,
    DataTypes.MatterTypes,
    DataTypes.OpeningBalances,
    DataTypes.ActivityTypes,
    DataTypes.UnbilledTimeAndFees,
    DataTypes.UnbilledDisbursements,
  ];

  // If productId is empty, return only the basic import types
  if (!productId) {
    return allowedImportTypes;
  }

  // Add memos, tasks, and events if productId is BOOST, GROW, or PROSPER
  if (
    productId === PRODUCT_TIERS.BOOST ||
    productId === PRODUCT_TIERS.GROW ||
    productId === PRODUCT_TIERS.PROSPER
  ) {
    allowedImportTypes.push(DataTypes.Memos, DataTypes.Tasks, DataTypes.Events);
  }

  // Add Matter Tags, Matter Relationships, and Matter Critial Dates if productId is GROW or PROSPER
  if (isGrowOrProsper) {
    allowedImportTypes.push(
      DataTypes.MatterTags,
      DataTypes.MatterRelationships,
      DataTypes.MatterCriticalDates,
      DataTypes.MatterArchiveDetails,
    );
  }

  // Add Safe Custody Packets and Documents if productId is GROW or PROSPER and region is not US
  if (isGrowOrProsper && region !== "US") {
    allowedImportTypes.push(
      DataTypes.SafeCustodyPackets,
      DataTypes.SafeCustodyDocuments,
    );
  }

  return allowedImportTypes;
};
